<template>
  <div class="flex flex-col relative h-screen">
    <h1 class="flex justify-center text-white uppercase text-md lg:text-3xl mt-20 tracking-wider">
      Teachers
    </h1>
    <router-link to="/teachers" class="absolute top-40 right-3 w-14 h-14 bg-white z-30 rounded
      md:flex items-center justify-center transform hover:scale-110 duration-300 hidden"
        >
      <div class="w-6">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 158 153"><defs>
        </defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1">
        <path class="grid-1" d="M64.2,71.5H11.8A10.3,10.3,0,0,1,1.5,61.2V11.8A10.3,10.3,0,0,1,11.8,
        1.5H64.2A10.3,10.3,0,0,1,74.5,11.8V61.2A10.3,10.3,0,0,1,64.2,71.5Z"/>
        <path class="grid-1" d="M146.26,151.5H93.8a10.3,10.3,0,0,1-10.3-10.3V91.8A10.3,
        10.3,0,0,1,93.8,81.5h52.4a10.3,10.3,0,0,1,10.3,10.3v49.44A10.17,10.17,0,0,1,146.26,151.5Z"/>
        <path class="grid-1" d="M64.2,151.5H11.8A10.3,10.3,0,0,1,1.5,141.2V91.8A10.3,10.3,0,0,1,
        11.8,81.5H64.2A10.3,10.3,0,0,1,74.5,91.8v49.4A10.3,10.3,0,0,1,64.2,151.5Z"/>
        <path class="grid-1" d="M145.26,71.5H92.8A10.3,10.3,0,0,1,82.5,61.2V11.8A10.3,10.3,0,0,
        1,92.8,1.5h52.4a10.3,10.3,0,0,1,10.3,10.3V61.24A10.17,10.17,0,0,1,145.26,71.5Z"/></g>
        </g></svg>
      </div>
    </router-link>
    <button aria-label="slide backward" class="absolute z-20 left-0 pl-10 focus:outline-none
      cursor-pointer inset-y-0 hover:bg-white hover:opacity-25 w-20">
      <svg class="dark:text-gray-900" width="8" height="14" viewBox="0 0 8 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      </svg>
    </button>
    <div class="flex justify-start items-center flex-col md:flex-row w-screen
      py-10 bg-white z-10 md:px-10 blur h-full mt-3
      snap-x overflow-x-auto">
      <teacher-card class="md:block hidden snap-center"
        v-for="teacher in filteredTeachers" :key="teacher.id"
        :teacher="teacher"
      />
      <teacher-card-mobile class="block md:hidden"
        v-for="teacher in filteredTeachers" :key="'mobile_'+teacher.id"
        :teacher="teacher"
      />
    </div>
    <button aria-label="slide forward" class="absolute z-20 right-0 pl-10 focus:outline-none
      cursor-pointer inset-y-0 hover:bg-white hover:opacity-25 w-20 overflow-x-scroll
      overscroll-x-auto"
      @click="element.scrollLeft({behavior: 'smooth', inline: 'start'})">
       <svg class="dark:text-gray-900" width="8" height="14" viewBox="0 0 8 14" fill="none"
      xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</template>

<script>
import TeacherCard from '@/components/teachers/TeacherCard.vue';
import { mapGetters } from 'vuex';
import { getTeachers } from '@/services/TeacherService';
import TeacherCardMobile from './TeacherCardMobile.vue';

export default {
  data() {
    return {
      teachers: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    filteredTeachers() {
      if (this.teachers.length > 0) {
        return this.teachers.filter(
          (teacher) => (!this.authenticated || teacher.user_id !== this.user.id),
        );
      }
      return true;
    },
  },

  components: {
    TeacherCard,
    TeacherCardMobile,
  },

  mounted() {
    this.loadTeachersList();
  },

  methods: {
    loadTeachersList() {
      getTeachers().then((response) => {
        this.teachers = response.data.sort(
          (teacher1, teacher2) => teacher2.stars_avg - teacher1.stars_avg,
        );
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },
  },

};
</script>

<style lang="scss" scoped>
  .blur{
    background: rgb(255, 255, 255, 0.8);
    box-shadow: 0 3px 20px 0 rgba(92, 92, 92, 0.842);
    backdrop-filter: blur( 3.0px );
    -webkit-backdrop-filter: blur( 3.0px );
  }
  .grid-1{
    fill: #a1a3a6;
    stroke: #a1a3a6;
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }
  .nav-tabs {
    flex-wrap: nowrap;
    white-space: nowrap;
    max-width: 500px;
    overflow: auto;
}
</style>
